// 基于 Modal 的修改，主要是针对样式
// 使用参考 qcloud-mall-pc\src\views\personal-center\address\index.tsx
import { Modal } from 'antd';
import './index.scss';

// props将会加上下面这个
interface PartProps {
  isDeleteModal?: boolean;
}

export default (props: any & PartProps) => {
  const { isDeleteModal = false, ...restProps } = props;
  // 设计图上左边是确定，右边是取消,所以我这里使用order直接调换了顺序，但是不影响按钮事件的绑定
  const wrapClassName = `u-modal ${isDeleteModal ? 'isDeleteModal' : ''}`;
  return (
    <Modal
      okButtonProps={{ style: { order: 1 } }} // 调整确认按钮的顺序
      cancelButtonProps={{ style: { order: 2 } }}
      wrapClassName={wrapClassName}
      {...restProps}
    />
  );
};
